var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 225,
    viewBox: "0 0 430 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3593_16984)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3593_16984",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -15,
    y: -63,
    width: 453,
    height: 264
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M332.401 199.958C392.484 194.557 426.176 147.149 437.351 131.157L414.426 -62.3457L-14.3109 -23.8068L-2.43901 76.3999C0.0684042 97.5642 18.1479 118.638 48.8091 122.867C77.105 126.769 108.232 98.318 135.258 101.564C162.284 104.809 174.162 115.964 197.369 137.887C226.905 165.789 257.297 206.709 332.401 199.958Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3593_16984)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3593_16984)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429.466,
    height: 284.455,
    transform: "matrix(-0.995984 0.0895286 0.117651 0.993055 414.031 -61.437)",
    fill: "url(#paint0_linear_3593_16984)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3593_16984",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -62,
    width: 431,
    height: 233
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.5 170.314C377.9 170.314 417 128.773 430 113.864V-62H-1V38.742C-1 60.0194 14.5 82.5995 44.5 89.5472C72.1856 95.9589 106.5 70.4409 133 76.086C159.5 81.731 170 93.8895 190.5 117.772C216.591 148.169 266.5 170.314 317.5 170.314Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3593_16984)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_3593_16984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430 -1H-0.999969V223H430V-1Z",
    fill: "url(#paint1_linear_3593_16984)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3593_16984",
    x: -71.7109,
    y: -119.437,
    width: 577.208,
    height: 436.928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3593_16984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3593_16984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3593_16984",
    x: -59,
    y: -59,
    width: 547,
    height: 340,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3593_16984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3593_16984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3593_16984",
    x1: 315.794,
    y1: 148.698,
    x2: 335.907,
    y2: 195.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03D15",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3593_16984",
    x1: 214.5,
    y1: -1,
    x2: 214.5,
    y2: 223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA1211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D13924"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3593_16984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.014aa00da289a31ffc4b9130571995cf.svg";
export { ForwardRef as ReactComponent };